import axios from "axios";
import { baseURL } from "../Constants";

const url = `${baseURL}/UnsignedGraphics`;

export interface UnsignedPlayer {
    steamId: string;
    nickname: string;
    hasPhoto: boolean;
    hidden: boolean;
    gamesPlayed: number; // maps played for the team this season
}

export interface UnsignedMatch {
    challongeId: string;
    matchTimeUtc: string; // ISO with Z
    division: string;
    opponent: { teamId: string; teamName: string };
    stream: string | null;
}

export interface UnsignedTeam {
    teamId: string;
    teamName: string;
    players: UnsignedPlayer[];
    matches: UnsignedMatch[];
}

export interface UnsignedTeamsResponse {
    teams: UnsignedTeam[];
    mentions: Record<string, string>; // opponent teamId -> X mention
}

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

// Admin-only: every current-season Unsigned team with its upcoming matches and lineup.
export const getUnsignedTeams = async (): Promise<UnsignedTeamsResponse> =>
    (await axios.get<UnsignedTeamsResponse>(`${url}/teams`, auth())).data;

export const setMention = async (teamId: string, mention: string): Promise<void> => {
    await axios.post(`${url}/mention`, { teamId, mention }, auth());
};

export const setStream = async (challongeId: string, stream: string): Promise<void> => {
    await axios.post(`${url}/stream`, { challongeId, stream }, auth());
};

export const setHidden = async (teamId: string, steamId: string, hidden: boolean): Promise<void> => {
    await axios.post(`${url}/hidden`, { teamId, steamId, hidden }, auth());
};

// Admin-only: sets the player's photo on PowerStats itself, not just on the card.
export const uploadPlayerPhoto = async (steamId: string, file: File): Promise<void> => {
    const form = new FormData();
    form.append("file", file);
    await axios.post(`${baseURL}/Account/Profile/${steamId}/upload`, form, auth());
};

// Anonymous and CORS-open, so html-to-image can inline them when exporting the card.
export const crestUrl = (teamId: string) => `${url}/crest/${teamId}`;
export const figureUrl = (steamId: string, version?: number) =>
    `${url}/figure/${steamId}${version ? `?v=${version}` : ""}`;
